// src/utils/socketClient.js
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_DIRECCION;

const socket = io(SOCKET_URL, {
  transports: ['websocket'],
  withCredentials: true, // Enviar cookie de sesión para autenticación
  autoConnect: false, // No conectar hasta que el usuario esté autenticado
});

export default socket;
